import { useSignalR } from "@webcore/hooks/useSignalR.ts";
import { useCoreApplicationContext } from "@webcore/context-providers/CoreApplicationContextProvider.tsx";

/**
 * Connects the read-only MFE session to SignalR so server-side data changes (Cosmos change feed,
 * GitHub pushes) invalidate the shared RTK Query cache and the rendered view/widget refreshes
 * without a manual reload. Rendered under the CoreApplicationContextProvider (inside MfeBootstrap's
 * ready state), so the session cookie exists and the active team is available — the connection
 * negotiates authenticated and joins the team's group.
 */
function MfeRealtimeSync() {
  const { activeTeam } = useCoreApplicationContext();
  useSignalR(activeTeam.id);
  return null;
}

export default MfeRealtimeSync;
